import { normaliseUsername, SUPPORT_EMAIL } from '@psyomics/ui-common';
import { BackLink, ForgotPasswordForm } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { getConfig } from '../../../config';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { patientApiUrl } = getConfig();
  const navigate = useNavigate();
  const { organisation } = useParams();

  const handleSubmit = async ({ username }: { username: string }) => {
    try {
      const response = await fetch(`${patientApiUrl}/auth/forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: normaliseUsername(username),
          ...(organisation && { organisationCode: organisation }),
        }),
      });

      if (!response.ok) {
        throw new Error(t('common.errors.generic', { supportEmail: SUPPORT_EMAIL }));
      }

      navigate('/forgot-password/confirm', { state: { username } });
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error(t('common.errors.networkError'));
    }
  };

  return (
    <div className="form-container">
      <BackLink text={t('common.buttons.goBack')} />
      <ForgotPasswordForm onSubmit={handleSubmit} />
    </div>
  );
};

export { ForgotPassword };
